/* Cats Garage — global.js
   (a) AJAX add-to-cart for form[data-ajax-add]; Shopify's 422 message (e.g. more
       than is in stock) shows in the form's [data-cart-error] slot when it has one
   (b) Quantity steppers ([data-qty-plus]/[data-qty-minus] inside [data-qty-wrapper])
   (c) Cart page: input[data-cart-qty] changes update the cart in place and
       redraw [data-cart-section]; add-ons (a) redraw it too
   Vanilla JS, loaded with defer. Plain form fallbacks work without JS. */
(function () {
  'use strict';

  var routes = window.CGRoutes || { cartAdd: '/cart/add', cart: '/cart' };

  function updateCartCount(cart) {
    var el = document.getElementById('cart-count');
    if (!el) return;
    el.textContent = cart.item_count;
    el.classList.toggle('is-empty', cart.item_count === 0);
  }

  function quantityInCart(cart, variantId) {
    var quantity = 0;
    (cart.items || []).forEach(function (item) {
      if (String(item.variant_id) === String(variantId)) quantity += item.quantity;
    });
    return quantity;
  }

  /* ---------- (a) AJAX add to cart ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[data-ajax-add]')) return;
    event.preventDefault();

    var button = form.querySelector('button[type="submit"], [type="submit"]');
    var originalText = button ? button.textContent : '';
    if (button) button.disabled = true;

    // Forms with a [data-cart-error] slot show Shopify's 422 message there.
    // A 422 on a quantity above stock still adds what is in stock, so
    // re-posting the form would only land the customer on an error page.
    var errorEl = form.querySelector('[data-cart-error]');
    if (errorEl) errorEl.hidden = true;
    var body = new FormData(form);
    var rejection = null;

    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      body: body,
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (response.status === 422 && errorEl) {
          return response.json().then(function (error) {
            rejection = error.description || error.message || 'Could not add this to your cart.';
          });
        }
        if (!response.ok) throw new Error('Add to cart failed: ' + response.status);
        return response.json();
      })
      .then(function () {
        return fetch(routes.cart + '.js');
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        if (rejection) {
          var inCart = quantityInCart(cart, body.get('id'));
          errorEl.textContent = rejection + (inCart ? ' Your cart has ' + inCart + ' of this item.' : '');
          errorEl.hidden = false;
          if (button) {
            button.textContent = originalText;
            button.disabled = false;
          }
          return;
        }
        if (button) {
          button.textContent = 'Added ✓';
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1800);
        }
      })
      .catch(function () {
        // Fall back to a regular (non-AJAX) submit.
        if (button) {
          button.textContent = originalText;
          button.disabled = false;
        }
        form.removeAttribute('data-ajax-add');
        form.submit();
      });
  });

  /* ---------- (b) Quantity steppers ---------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-plus], [data-qty-minus]');
    if (!button) return;

    var wrapper = button.closest('[data-qty-wrapper]');
    var input = wrapper && wrapper.querySelector('input');
    if (!input) return;

    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = 0;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 0;

    value = button.hasAttribute('data-qty-plus') ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- (c) Cart page: update in place ---------- */
  // A reload per tap made quick taps flicker and get lost. Quantity changes
  // now wait for a short pause, then go to /cart/update.js one request at a
  // time, keyed by line so a stale page can't misapply them, and the cart is
  // redrawn from the section HTML Shopify bundles into the response. Anything
  // unexpected falls back to the plain form submit (a reload).
  var cartTimer = null;
  var cartSeq = 0;
  var cartQueue = Promise.resolve();
  var cartLeaving = false;

  function queueCart(task) {
    cartQueue = cartQueue.then(task).catch(function () {});
  }

  function cartUpdates() {
    var updates = {};
    document.querySelectorAll('[data-cart-section] input[data-cart-qty][data-line-key]').forEach(function (input) {
      var quantity = parseInt(input.value, 10);
      if (!isNaN(quantity) && quantity >= 0) updates[input.getAttribute('data-line-key')] = quantity;
    });
    return updates;
  }

  function postCartUpdate(body) {
    return fetch(routes.cart + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      keepalive: true
    });
  }

  // Swap in a fresh [data-cart-section], keeping keyboard focus on the same
  // control of the same line while the lines are unchanged.
  function drawCart(html) {
    var root = document.querySelector('[data-cart-section]');
    var next = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
    if (!root || !next) throw new Error('Cart section missing');
    var lines = root.querySelectorAll('[data-qty-wrapper]');
    var active = document.activeElement;
    var line = active && root.contains(active) ? active.closest('[data-qty-wrapper]') : null;
    var lineIndex = Array.prototype.indexOf.call(lines, line);
    var controlIndex = line ? Array.prototype.indexOf.call(line.querySelectorAll('button, input'), active) : -1;
    root.replaceWith(next);
    var nextLines = next.querySelectorAll('[data-qty-wrapper]');
    if (lineIndex >= 0 && nextLines.length === lines.length) {
      var control = nextLines[lineIndex].querySelectorAll('button, input')[controlIndex];
      if (control) control.focus();
    }
  }

  function sendCartUpdate(seq) {
    var root = document.querySelector('[data-cart-section]');
    if (!root) return;
    var sectionId = root.getAttribute('data-cart-section');
    return postCartUpdate({ updates: cartUpdates(), sections: sectionId })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed: ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart);
        // Only the newest change redraws; older answers are already stale.
        if (seq === cartSeq && !cartTimer) drawCart((cart.sections || {})[sectionId]);
      })
      .catch(function () {
        var form = document.querySelector('form[data-cart-form]');
        if (form && !cartLeaving) form.submit();
      });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[data-cart-qty]')) return;
    var form = input.closest('form[data-cart-form]');
    var root = input.closest('[data-cart-section]');
    if (!root || !input.hasAttribute('data-line-key') || !window.DOMParser) {
      if (form) form.submit();
      return;
    }
    root.setAttribute('aria-busy', 'true');
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      cartTimer = null;
      var seq = ++cartSeq;
      queueCart(function () {
        return sendCartUpdate(seq);
      });
    }, 300);
  });

  // Enter (Go on a phone keypad) in a quantity box would press Checkout, the
  // form's only submit button; commit the number instead.
  document.addEventListener('keydown', function (event) {
    var input = event.target;
    if (event.key !== 'Enter' || !input.matches || !input.matches('input[data-cart-qty]')) return;
    event.preventDefault();
    input.blur();
  });

  // Checkout posts the form with the latest numbers itself.
  document.addEventListener('submit', function (event) {
    if (!event.target.matches || !event.target.matches('form[data-cart-form]')) return;
    clearTimeout(cartTimer);
    cartTimer = null;
    cartLeaving = true;
  });

  // Leaving during the pause: save the last change in the background.
  window.addEventListener('pagehide', function () {
    if (!cartTimer) return;
    clearTimeout(cartTimer);
    cartTimer = null;
    postCartUpdate({ updates: cartUpdates() }).catch(function () {});
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) cartLeaving = false;
  });

  // Top-up add-ons on the cart page are added with AJAX (a); redraw the cart
  // so the new line, totals and free-delivery bar show up.
  document.addEventListener('cart:updated', function () {
    var root = document.querySelector('[data-cart-section]');
    if (!root) return;
    var seq = cartSeq;
    var url = routes.cart + '?section_id=' + encodeURIComponent(root.getAttribute('data-cart-section'));
    queueCart(function () {
      return fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Cart refresh failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          // A quantity change since then redraws with this line included.
          if (seq === cartSeq && !cartTimer) drawCart(html);
        })
        .catch(function () {
          window.location.reload();
        });
    });
  });
})();
